import PropTypes from "prop-types";
import React from "react";

const TONE = {
  returning: "returning",
  new: "new",
};

const StatusBadge = ({ label }) => (
  <span className={`rp-badge rp-badge--${label ? TONE[label.toLowerCase()] || "grey" : "grey"}`}>{label || "Unknown"}</span>
);

StatusBadge.propTypes = { label: PropTypes.string.isRequired };

export default StatusBadge;
